export const affectedLotLayerDefinition = {
    geometryType: 'esriGeometryPoint',
    objectIdField: 'uniqueId',
    extent: {
        xmin: -180,
        ymin: -90,
        xmax: 180,
        ymax: 90,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'Id',
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeInteger',
            alias: 'type',
            editable: true,
            nullable: true
        },
        {
            name: 'affectedlotland',
            type: 'esriFieldTypeString',
            alias: 'AffectedLotLand',
            editable: true,
            nullable: false,
            length: 1024
        },
        {
            name: 'plannumber',
            type: 'esriFieldTypeString',
            alias: 'PlanNumber',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'lotnumber',
            type: 'esriFieldTypeString',
            alias: 'LotNumber',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'plantypedesc',
            type: 'esriFieldTypeString',
            alias: 'PlanTypeDesc',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'commonproperty',
            type: 'esriFieldTypeString',
            alias: 'CommonProperty',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'titlereference',
            type: 'esriFieldTypeString',
            alias: 'TitleReference',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'subjectlanddescription',
            type: 'esriFieldTypeString',
            alias: 'SubjectLandDescription',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'affectedtenureid',
            type: 'esriFieldTypeInteger',
            alias: 'AffectedTenureId',
            editable: true,
            nullable: false
        }
    ]
};
